import styles from './Header.module.css';
import SearchBar from './SearchBar';

const Header = (props) => {
  return (
    <div className={styles['municipality-header']}>
      <div className={styles['municipality-header_left']}>
        <h2 style={{ marginTop: 0, marginBottom: 12 }}>{props.title}</h2>
        <p>{props.description}</p>
      </div>
      <SearchBar setSearchInputValue={props.setSearchInputValue} title={props.placeholder} />
    </div>
  );
};

export default Header;
